import React, { useEffect, useContext, useState } from "react";
import { Button, Form, Row, Col, Card, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faCube,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import "./Summary.css";
import { Context } from "../../../../utils/context";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getData, postData } from "../../../../utils/api";
import OrderPlacedModal from "../OrderPlacedModal";
import ErrorModal from "../ErrorModal";
import GST_modal from "../../../common/gst_modal/GST_modal";
import Green_Btn from "../../../common/green_btn/Green_Btn";
import { ClipLoader } from "react-spinners";
import { Code } from "lucide-react";
import View_All_Coupon_Code from "./view_All_Coupon_Code/View_All_Coupon_Code";

function Summary({ prescription, user_id, setValue, watch, getValues }) {
  const [paymentMethod, setPaymentMethod] = useState("1"); // default
  const [rewardData, setRewardData] = useState(false);
  const { toggleSidebar } = useContext(Context);

  const [orderSummary, setOrderSummary] = useState();
  const [orderDetailsSummary, setOrderDetailsSummary] = useState();
  const [GSTNumber, setGSTNumber] = useState("");
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowCoupon, setModalShowCoupon] = React.useState(false);
  const [CouponCode, setCouponCode] = useState("");
  const [Code, setCode] = useState("");
  const [CouponError, setCouponError] = useState("");
  const [Message, setMessage] = useState("");
  const [CouponApply, setCouponApply] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSuccessReward, setShowSuccessReward] = useState(false);

  const [rewardStatus, setRewardStatus] = useState(false);
  const [couponStatus, setCouponStatus] = useState(false);
  const calculateOrder = async (arr) => {
    // if (!user_id) {
    //   alert("Please Add User Details...!");
    //   return false;
    // }
    const res = await postData(`/admin/orders/calculate`, {
      products: arr,
      reward_status: rewardData,
      code: CouponCode,
      user_id,
    });

    if (res?.success) {
      await setOrderSummary(res?.data?.order_summary);
      await setOrderDetailsSummary(res?.data?.order_Details_summary);
      await setCouponError(res?.data?.order_summary?.message);
      if (
        res?.data?.order_summary?.coupon_applied &&
        CouponCode &&
        couponStatus
      ) {
        setMessage("Coupon applied successfully.");
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          setCouponStatus(false);
        }, 2000);
      } else if (
        res?.data?.order_summary?.reward_status &&
        rewardData &&
        rewardStatus
      ) {
        setMessage("Reward applied successfully.");
        setShowSuccessReward(true);
        setTimeout(() => {
          setShowSuccessReward(false);
          setRewardStatus(false);
        }, 2000);
      } else if (CouponCode) {
        setCouponCode("");
        setCode("");
        setCouponApply(false);
        setMessage(res?.data?.order_summary?.message);
        setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 2000);
      }
    }
  };

  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();
  const [advancePayment, setAdvancePayment] = useState(0);
  const [DoctorName, setDoctorName] = useState("");

  const [loader, setLoder] = useState(false);

  const createOrder = async () => {
    setLoder(true);
    if (!paymentMethod) {
      alert("Please Select Payment Method...!");
      return false;
    }
    if (!user_id) {
      alert("Please Add User Details...!");
      return false;
    }

    if (orderDetailsSummary?.length <= 0) {
      alert("Product Required...!");
      return false;
    }
    const finalData = new FormData();
    finalData.append("order_summary", JSON.stringify(orderSummary));
    finalData.append(
      "order_Details_summary",
      JSON.stringify(orderDetailsSummary),
    );
    finalData.append("payment_method_id", paymentMethod);
    finalData.append("user_id", user_id);

    finalData.append("advance_amount", advancePayment);
    finalData.append("gst_number", GSTNumber);

    finalData.append("doctor_name", DoctorName);

    const res = await postData(`/admin/orders`, finalData);

    if (res?.success) {
      setMessage("Order Placed Successfully!");
      await setShowSuccess(true);
      setLoder(false);
      setTimeout(() => {
        setShowSuccess(false);
        toggleSidebar();
        navigate("/orders/all-orders");
      }, 3000);
    } else {
      setLoder(false);
      setMessage(res?.errors);
      await setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 3000);
    }
  };

  useEffect(() => {
    const subscription = watch((values) => {
      if (values.products && Array.isArray(values.products)) {
        const arr = values.products
          .filter(
            (p) => p?.product_details && p?.product_details?.id,
            // &&
            // p?.product_details?.Stock?.barcode_no
          )
          .map((p) => ({
            product_id: p.product_details.id,
            category_id: p.product_details.p_category_id,
            brand_id: p.product_details.brand_id,
            prescription_id:
              p.product_details.prescription_details?.prescription?.id,
            addon_id: p.product_details.addon_details?.id,
            lense_id: p.product_details.lens_details?.id,
            lense_category_id: p.product_details.lens_details?.p_category_id,
            lense_brand_id: p?.product_details.lens_details?.brand_id,
            stock_lense_id: p.product_details.lens_details?.Stock?.id,
            barcode_no: p?.product_details?.Stock?.barcode_no,
            quantity: 1,
          }));

        calculateOrder(arr);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    const values = getValues(); // from react-hook-form
    if (values.products && Array.isArray(values.products)) {
      const arr = values.products
        .filter(
          (p) =>
            p?.product_details &&
            p?.product_details?.id &&
            p?.product_details?.Stock?.barcode_no,
        )
        .map((p) => ({
          product_id: p.product_details.id,
          category_id: p.product_details.p_category_id,
          brand_id: p.product_details.brand_id,
          prescription_id:
            p.product_details.prescription_details?.prescription?.id,
          addon_id: p.product_details.addon_details?.id,
          lense_id: p.product_details.lens_details?.id,
          stock_lense_id: p.product_details.lens_details?.Stock?.id,
          barcode_no: p?.product_details?.Stock?.barcode_no,
          quantity: 1,
        }));

      calculateOrder(arr);
    }
  }, [rewardData, CouponApply]);

  // useEffect(() => {
  //   const subscription = watch((values) => {
  //     if (values.products && Array.isArray(values.products)) {
  //       const arr = values.products
  //         .filter((p) => p?.product_details && p?.product_details?.id)
  //         .map((p) => {
  //           if (p.product_details.p_category_id === Category.Lenses) {
  //             return {
  //               prescription_id:
  //                 p.product_details.prescription_details?.prescription?.id,
  //               addon_id: p.product_details.addon_details?.id,
  //               lense_id: p.product_details.id,
  //               lense_category_id: p.product_details.p_category_id,
  //               lense_brand_id: p.product_details.brand_id,
  //               stock_lense_id: p.product_details.lens_details?.Stock?.id,
  //               barcode_no: p?.product_details?.Stock?.barcode_no,
  //               quantity: 1,
  //             };
  //           } else {
  //             return {
  //               product_id: p.product_details.id,
  //               category_id: p.product_details.p_category_id,
  //               brand_id: p.product_details.brand_id,
  //               prescription_id:
  //                 p.product_details.prescription_details?.prescription?.id,
  //               addon_id: p.product_details.addon_details?.id,
  //               lense_id: p.product_details.lens_details?.id,
  //               lense_category_id:
  //                 p.product_details.lens_details?.p_category_id,
  //               lense_brand_id: p?.product_details.lens_details?.brand_id,
  //               stock_lense_id: p.product_details.lens_details?.Stock?.id,
  //               barcode_no: p?.product_details?.Stock?.barcode_no,
  //               quantity: 1,
  //             };
  //           }
  //         });

  //       calculateOrder(arr);
  //     }
  //   });

  //   return () => subscription.unsubscribe();
  // }, [watch]);
  const [userWallet, setUserWallet] = useState(false);

  const userWalletdata = async (arr) => {
    const res = await getData(`/admin/wallet/${user_id}`);
    setUserWallet(res);
  };

  useEffect(() => {
    userWalletdata();
  }, [user_id]);

  useEffect(() => {
    setAdvancePayment(orderSummary?.total_amount);
  }, [orderSummary?.total_amount]);

  const grandTotal = Number(orderSummary?.total_amount || 0);
  const remainingAmount = Math.max(grandTotal - Number(advancePayment || 0), 0);
  const handleApplyCoupon = (code) => {
    setCode(code);
    setCouponCode(code);
    if (!code.trim()) {
      setCouponError("Coupon code is required");
      return;
    }
    setModalShowCoupon(false);
    setCouponStatus(true);
    setCouponError("");
    setCouponApply(true);
  };
  return (
    <>
      <section className="summary-container">
        <h4 className="summary-title">Summary</h4>

        <Card className="summary-card shadow-sm p-0">
          <Card.Body>
            <Row className="summary-row">
              <Col>Items</Col>
              <Col className="text-end fw-bold">
                {Number(orderSummary?.no_of_item)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Product MRP</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_mrp).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Product Discounted Price</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_selling_price).toFixed(2)}
              </Col>
            </Row>
            <Row className="summary-row">
              <Col>Product Discount</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_discount).toFixed(2)}
              </Col>
            </Row>
            <Row className="summary-row">
              <Col>Lens MRP</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_lense_mrp).toFixed(2)}
              </Col>
            </Row>
            <Row className="summary-row">
              <Col>Lens Price</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_lense_price).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Lens Discount</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_lense_discount).toFixed(2)}
              </Col>
            </Row>
            <Row className="summary-row">
              <Col>Addon Price</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_addon_price).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Product Tax</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_tax).toFixed(2)}
              </Col>
            </Row>
            <Row className="summary-row">
              <Col>Lens Tax</Col>
              <Col className="text-end">
                ₹ {Number(orderSummary?.total_lense_tax).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Coupon Discount</Col>
              <Col className="text-end text-danger">
                - ₹ {Number(orderSummary?.total_coupon_discount).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Offer Discount</Col>
              <Col className="text-end text-danger">
                - ₹ {Number(orderSummary?.total_offer_discount).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Reward Discount</Col>
              <Col className="text-end text-danger">
                - ₹ {Number(orderSummary?.reward_discount).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>Shipping</Col>
              <Col className="text-end text-danger">
                ₹ {Number(orderSummary?.total_delivery_charges).toFixed(2)}
              </Col>
            </Row>

            <Row className="summary-row">
              <Col>
                Reward Points
                <br />
                <span style={{ color: "orange" }}>
                  ({Number(userWallet?.data?.amount).toFixed(2) || 0}{" "}
                  {rewardData ? "Used" : "available"} )
                </span>
                {/* {parseFloat(orderSummary?.total_amount) +
                  parseFloat(orderSummary?.reward_discount) >=
                parseFloat(userWallet?.data?.amount) * 2 ? (*/}
                <Badge
                  bg={rewardData ? "danger" : "secondary"}
                  onClick={() => {
                    setRewardData(!rewardData);
                    setRewardStatus(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {rewardData ? "Remove" : "Apply"}
                </Badge>
                {/* ) : (
                  <Badge bg="secondary" disabled style={{ opacity: 0.5 }}>
                    Apply
                  </Badge>
                )}*/}
                {/* {parseFloat(orderSummary?.order_summary?.total_amount) >=
                parseFloat(userWallet?.user_wallet?.amount) * 2 ? (
                  <Badge
                    bg={rewardData ? "danger" : "secondary"} // Use "danger" instead of "red" (Bootstrap color)
                    onClick={() => setRewardData(!rewardData)}
                    style={{ cursor: "pointer" }}
                  >
                    {rewardData ? "Remove" : "Apply"}
                  </Badge>
                ) : (
                  <Badge bg="secondary" disabled style={{ opacity: 0.5 }}>
                    Apply
                  </Badge>
                )} */}
              </Col>

              <Col className="text-end text-danger">
                ₹ {Number(orderSummary?.reward_discount).toFixed(2)}
              </Col>
            </Row>

            <hr />

            <Row className="summary-row align-items-center">
              <Col>GST Number</Col>
              <Col className="text-end text-danger">
                <div className="row-divider">
                  <div className="qty_div">
                    <Green_Btn
                      onClick={() => setModalShow(true)}
                      btn_name="GST Number"
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="summary-row total-row">
              <Col>Grand Total</Col>
              <Col className="text-end fw-bold fs-6 text-success">
                ₹ {Number(orderSummary?.total_amount).toFixed(2)}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        {/* ✅ Payment Method Options */}
        <Card className="mt-3 shadow-sm">
          <Card.Body>
            <h6 className="fw-bold mb-3">Select Payment Method</h6>
            <Form>
              <div className="d-flex justify-content-between">
                <Form.Check
                  type="radio"
                  id="cash"
                  label="💵 Cash"
                  value="1"
                  name="paymentMethod"
                  checked={paymentMethod === "1"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <Form.Check
                  type="radio"
                  id="online"
                  label="💳 Online"
                  value="3"
                  name="paymentMethod"
                  checked={paymentMethod === "3"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                {/* <Form.Check
                  type="radio"
                  id="wallet"
                  label="👛 Wallet"
                  value="4"
                  name="paymentMethod"
                  checked={paymentMethod === "4"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                /> */}
              </div>
            </Form>
          </Card.Body>
        </Card>
        <Row className="summary-row align-items-center">
          <Col>Advance Payment</Col>
          <Col className="text-end">
            <Form.Control
              type="number"
              min="0"
              max={grandTotal}
              value={advancePayment === 0 ? "" : advancePayment}
              onChange={(e) => {
                const raw = e.target.value;

                // allow clearing the field
                if (raw === "") {
                  setAdvancePayment("");
                  return;
                }

                const value = Number(raw);

                if (!isNaN(value) && value > 0 && value <= grandTotal) {
                  setAdvancePayment(value);
                }
              }}
              // className="text-end"
              placeholder="0.00"
              size="sm"
            />
          </Col>
        </Row>

        <Row className="summary-row">
          <Col>Remaining Amount</Col>
          <Col className="text-end fw-bold text-warning">
            ₹ {remainingAmount.toFixed(2)}
          </Col>
        </Row>
        <Row className="summary-row align-items-center">
          <Col>Doctor Name</Col>
          <Col className="text-end">
            <Form.Control
              type="text"
              value={DoctorName}
              onChange={(e) => {
                const raw = e.target.value;
                setDoctorName(raw);
              }}
              // className="text-end"
              placeholder="Doctor Name"
              size="sm"
            />
          </Col>
        </Row>

        <Row className="summary-row align-items-center">
          <Col>Coupon Code</Col>

          <Col>
            <Form.Control
              type="text"
              value={Code}
              onChange={(e) => {
                setCode(e.target.value);
                // setCouponStatus(true);
              }}
              // className="text-end"
              placeholder="Code"
              size="sm"
            />
          </Col>
        </Row>

        <Row className="summary-row align-items-center justify-content-end">
          {orderSummary?.coupon_applied ? (
            <Col lg={3} className="text-end">
              <Button
                size="sm"
                onClick={() => {
                  setCouponError("Coupon Remove First");
                }}
              >
                View All Coupon
              </Button>
            </Col>
          ) : (
            <Col lg={3} className="text-end">
              <Button size="sm" onClick={() => setModalShowCoupon(true)}>
                View All Coupon
              </Button>
            </Col>
          )}

          {orderSummary?.coupon_applied ? (
            <Col lg={3} className="text-end">
              <Button
                size="sm"
                onClick={() => {
                  setCouponApply(false);
                  setCouponCode("");
                  setCode("");
                }}
              >
                Remove
              </Button>
            </Col>
          ) : (
            <Col lg={2} className="text-end">
              <Button size="sm" onClick={() => handleApplyCoupon(Code)}>
                {/* <Button size="sm" onClick={() => setCouponApply(true)}> */}
                Apply
              </Button>
            </Col>
          )}

          {CouponError && <div style={{ color: "red" }}>{CouponError}</div>}
        </Row>

        {loader ? (
          <>
            <div className="text-center">
              <ClipLoader />
            </div>
          </>
        ) : (
          <Button className="place-order-btn w-100 mt-3" onClick={createOrder}>
            <FontAwesomeIcon icon={faCube} className="me-2" />
            Place Order
          </Button>
        )}
      </section>

      <OrderPlacedModal
        show={showSuccess}
        setShowSuccess={setShowSuccess}
        message={Message}
      />

      <OrderPlacedModal
        show={showSuccessReward}
        setShowSuccess={setShowSuccessReward}
        message={Message}
      />
      <ErrorModal
        show={showError}
        setShowSuccess={setShowError}
        message={Message}
      />

      <GST_modal
        GSTNumber={GSTNumber}
        setGSTNumber={setGSTNumber}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <View_All_Coupon_Code
        setCouponCode={setCouponCode}
        handleApplyCoupon={handleApplyCoupon}
        // onApply={(code) => {
        //   setCouponCode(code);
        //   // handleSubmit(onSubmit)();
        //   setModalShow(false); // hit apply API
        // }}
        show={modalShowCoupon}
        onHide={() => setModalShowCoupon(false)}
      />
    </>
  );
}

export default Summary;
